import React, { useState, useRef, useEffect } from "react";
import styles from "./ControlBar.module.css";
// import AddOrgIcon from "../../assets/icons/controlBar/addOrg.svg";
// import CreateEventIcon from "../../assets/icons/controlBar/createEvent.svg";
// import ExportDataIcon from "../../assets/icons/controlBar/exportData.svg";
// import ImportCSVIcon from "../../assets/icons/controlBar/importCSV.svg";
// import NewContactIcon from "../../assets/icons/controlBar/newContact.svg";
// import ThemeIcon from "../../assets/icons/controlBar/theme.svg";
import { useTheme } from "../../middleware/ThemeContext";
import ThemeIcon from "../../assets/icons/controlBar/ThemeIcon";
import ImportCSV from "../../assets/icons/controlBar/ImportCSV";
import ExportData from "../../assets/icons/controlBar/ExportData";
import NewContact from "../../assets/icons/controlBar/NewContact";
import CreateEvent from "../../assets/icons/controlBar/CreateEvent";
import AddOrg from "../../assets/icons/controlBar/AddOrg";
import DropdownButton from "../StyledComponents/StyledDropdownButton";
import ShortcutButton from "../StyledComponents/ShortcutButton";
import AddIcon from "../../assets/icons/AddIcon";
import ContactIcon from "../../assets/icons/ContactIcon";
import OrganizationIcon from "../../assets/icons/OrganizationIcon";

interface ControlBarProps {
  onNewContact: () => void;
  onNewOrganization?: () => void;
  onNewQuery?: () => void;
  onNewField?: () => void;
  onNewComponent?: () => void;
  onAddRoles?: () => void;
  onNewForm?: () => void;
  onImport?: (type: "contact" | "organization" | "relationship") => void;
  contact?: boolean;
  oranization?: boolean;
  events?: boolean;
  query?: boolean;
  roles?: boolean;
  field?: boolean;
  component?: boolean;
  form?: boolean;
  imports?: boolean;
  mapping?: boolean;
  preview?: boolean;
  widget?: boolean;
  membership?: boolean;
  onNewWidget?: () => void;
  onNewPlan?: () => void;
}

const ControlBar = ({
  onNewContact,
  onNewOrganization,
  onNewQuery,
  onNewForm,
  onNewField,
  onNewComponent,
  onAddRoles,
  onImport,
  form,
  query,
  roles,
  field,
  component,
  contact,
  imports,
  oranization = false,
  events = false,
  mapping,
  preview,
  widget,
  membership,
  onNewWidget,
  onNewPlan,

}: ControlBarProps) => {
  const { theme, toggleTheme } = useTheme();
  const [showThemeDropdown, setShowThemeDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowThemeDropdown(false);
      }
    };

    if (showThemeDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showThemeDropdown]);

  const renderButton = () => {
    if (imports) return false;
    if (mapping) return false;
    if (preview) return false
    return (
      <>
        <ShortcutButton icon={<ImportCSV color={theme.colors.topBarsColorText} />} label="Import CSV" />
        <ShortcutButton icon={<ExportData color={theme.colors.topBarsColorText} />} label="Export Data" /></>
    )
  }

  const renderEventOrganizationBtn = () => {
    if (imports) return null;
    return (
      <div className={styles.section}>
        {oranization && (
          <ShortcutButton
            icon={<AddOrg color={theme.colors.topBarsColorText} />}
            onClick={onNewOrganization}
            label="Add New Organization"
          />
        )}
        {events && <ShortcutButton icon={<CreateEvent />} label="Create Event" />}
      </div>
    );
  };

  const hasEventOrgSection = oranization || events;
  const hasMainSection = contact || query || roles || field || component || form || imports || widget || membership;
  const isVisible = hasEventOrgSection || hasMainSection;

  if (!isVisible) {
    return null;
  }


  return (
    <div className={styles.controlBar} style={{ backgroundColor: theme.colors.topBarsColorBG, borderColor: theme.colors.topBarsColorBorder }}>
      <div className={styles.section} style={{ width: oranization ? "100%" : "" }}>
        {/* {renderEventOrganizationBtn()} */}
        {/* <div className={styles.themeContainer} ref={dropdownRef}>
          <ShortcutButton
            icon={<ThemeIcon color={theme.colors.topBarsColorText} />}
            label="Theme"
            onClick={() => setShowThemeDropdown(!showThemeDropdown)}
          />
          {showThemeDropdown && (
            <div className={styles.themeDropdown}>
              <button
                onClick={() => {
                  if (theme.name !== "light") toggleTheme();
                  setShowThemeDropdown(false);
                }}
                className={`${styles.themeOption} ${theme.name === "light" ? styles.activeTheme : ""
                  }`}
              >
                <span className={styles.themeIndicator} />
                Light Theme
              </button>
              <button
                onClick={() => {
                  if (theme.name !== "dark") toggleTheme();
                  setShowThemeDropdown(false);
                }}
                className={`${styles.themeOption} ${theme.name === "dark" ? styles.activeTheme : ""
                  }`}
              >
                <span className={styles.themeIndicator} />
                Dark Theme
              </button>
            </div>
          )}
        </div> */}
        <div className={oranization ? "w-100 justify-content-end d-flex " : ""}>
          {renderEventOrganizationBtn()}
        </div>
      </div>
      <div className={styles.section}>
        {/* {renderButton()} */}
        {contact && !roles && !query && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Contact"
            onClick={onNewContact}
          />
        )}
        {query && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Query"
            onClick={onNewQuery}
          />
        )}
        {roles && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="Create Contact Roles"
            onClick={onAddRoles}
          />
        )}

        {field && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Field"
            onClick={onNewField}
          />
        )}
        {component && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Component"
            onClick={onNewComponent}
          />
        )}
        {form && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Form"
            onClick={onNewForm}
          />
        )}
        {imports && (
          <DropdownButton
            icon={<AddIcon color={theme.colors.topBarsColorText} />}
            iconPosition="right"
            buttonLabel="New Import"
            align="right"
            items={[
              { label: "Import Contact", onClick: () => onImport?.("contact"), icon: <ContactIcon color={theme.CorporateTheme.colors.textSecondary} /> },
              { label: "Import Organization", onClick: () => onImport?.("organization"), icon: <AddOrg color={theme.CorporateTheme.colors.textSecondary} /> },
              { label: "Import Relation", onClick: () => onImport?.("relationship"), icon: <OrganizationIcon color={theme.CorporateTheme.colors.textSecondary} /> },
            ]}
          />
        )}
        {widget && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="New Widget"
            onClick={onNewWidget}
          />
        )}
        {membership && (
          <ShortcutButton
            icon={<NewContact color={theme.colors.topBarsColorText} />}
            label="Create New Plan"
            onClick={onNewPlan}
          />
        )}

      </div>
    </div>
  );
};

export default ControlBar;


